<template>
  <div>
    <asc-spinner-wrapper :loading="loading">
      <asc-fault-monitor-item
        v-for="item in values"
        :key="item.title"
        class="asc-fault-monitor-list--margins"
        :item="item"
      ></asc-fault-monitor-item>
    </asc-spinner-wrapper>
    <asc-no-data v-if="isEmpty"></asc-no-data>
  </div>
</template>

<script>
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscNoData from '@/components/atoms/AscNoData'
import AscFaultMonitorItem from './AscFaultMonitorItem'

export default {
  name: 'AscFaultMonitorList',

  components: {
    AscFaultMonitorItem,
    AscSpinnerWrapper,
    AscNoData,
  },

  props: {
    values: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isEmpty() {
      return !this.loading && this.values.length === 0
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-fault-monitor-list--margins {
  margin-top: $size-medium;
}
</style>
